export const mapURL = {
    "fiveStarDomain":['emp5stardev.overturexl.com', 'qatestemployer5star.overturexl.com', '5staremployers.overturexl.com','5starstagingemployers.overturexl.com',],
    "lifeStyleDomain":['dynamicemployers.overturexl.com'],
    "nursesEtc":['nursesetcemployers.overturexl.com','qatestemployernursesetc.overturexl.com','devemployernursesetc.overturexl.com'],
    "pureHeart":['pureheartemployers.overturexl.com',]
};

export const domainLogo = {
    // FiveStar
    "fiveStarLogo":"assets/images/brand/5STAR.png",
    "fiveStarIcon":"assets/images/brand/ICON-5STAR.png",
    // OvertureLifeStyle
    "lifeStyleLogo":"assets/images/brand/LOGO-LSTYLE.png",
    "lifeStyleIcon":"assets/images/brand/ICON-LSTYLE.ico",
    // NursesETC
    "nursesEtcLogo":"assets/images/brand/LOGO-NETC.png",
    "nursesEtcIcon":"assets/images/brand/ICON-NETC.png",
    // PureHeart
    "pureHeartLogo":"assets/images/brand/LOGO-PUREHEART.png",
    "pureHeartIcon":"assets/images/brand/ICON-PUREHEART.png"
};


export const getInstanceLogo = (isIcon) => {
    const domainName = window.location.hostname;
    if(mapURL.fiveStarDomain?.includes(domainName)){
        return isIcon? domainLogo.fiveStarIcon :  domainLogo.fiveStarLogo;
    } else if(mapURL.lifeStyleDomain?.includes(domainName)){
        return isIcon ? domainLogo.lifeStyleIcon : domainLogo.lifeStyleLogo;
    } else if(mapURL.nursesEtc?.includes(domainName)){
        return isIcon ? domainLogo.nursesEtcIcon : domainLogo.nursesEtcLogo;
    } else if(mapURL.pureHeart?.includes(domainName)){
        return isIcon ? domainLogo.pureHeartIcon : domainLogo.pureHeartLogo;
    } else {
        return null;
    }
};


